import gql from 'graphql-tag';

const fragments = {
    GlobalMessages: gql`
        fragment GlobalInlineAlertGlobalMessages on GlobalMessages {
            alert {
                action {
                    link {
                        href
                        text {
                            value
                        }
                    }
                }
                body {
                    text {
                        value
                    }
                    link {
                        href
                        text {
                            value
                        }
                    }
                }
                id
                severity
                title {
                    value
                }
            }
        }
    `,
};

export default fragments;
